import script from "./withIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./withIcon.vue?vue&type=script&setup=true&lang=ts"

import "./withIcon.vue?vue&type=style&index=0&id=5d07cbe0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d07cbe0"]])

export default __exports__